import { Injectable } from '@angular/core';
import { APP_CONFIG } from './config.service';

/**
 * Initializes the global IGLOO object once configuration is loaded.
 * Uses APP_INITIALIZER ordering: AppConfigService.load populates APP_CONFIG first.
 */
@Injectable({ providedIn: 'root' })
export class IglooInitService {
  private initialized = false;

  init(): void {
    if (this.initialized) return;
    // Ensure config is available
    if (!APP_CONFIG) {
      // Config not yet loaded; skip. Caller (APP_INITIALIZER chain) will retry via a second initializer.
      return;
    }
    (window as any).io_global_object_name = 'IGLOO';
    (window as any).IGLOO = (window as any).IGLOO || {
      bbout_element_id: 'iobb',
      bb_callback: null,
      install_flash: false,
      enable_flash: false,
      enable_rip: true,
      loader: {
        uri_hook: 'iojs',
        version: 'general5',
        subkey: APP_CONFIG.fraudForceSubscriptionKey || ''
      }
    };
    this.initialized = true;
  }
}
